/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * RBAC API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetApiConfigs200Item,
  PatchApiConfigsConfigId200,
  PatchApiConfigsConfigIdBody,
  PostApiConfigs200,
  PostApiConfigsBody,
  PostApiDeleteConfigsConfigId200
} from '../../models';

import { customInstance } from '../../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export type getApiConfigsResponse200 = {
  data: GetApiConfigs200Item[]
  status: 200
}
    
export type getApiConfigsResponseSuccess = (getApiConfigsResponse200) & {
  headers: Headers;
};
;

export type getApiConfigsResponse = (getApiConfigsResponseSuccess)

export const getGetApiConfigsUrl = () => {


  

  return `/api/configs`
}

export const getApiConfigs = async ( options?: RequestInit): Promise<getApiConfigsResponse> => {
  
  return customInstance<getApiConfigsResponse>(getGetApiConfigsUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetApiConfigsQueryKey = () => {
    return [
    `/api/configs`
    ] as const;
    }

    
export const getGetApiConfigsQueryOptions = <TData = Awaited<ReturnType<typeof getApiConfigs>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiConfigs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiConfigsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiConfigs>>> = () => getApiConfigs(requestOptions);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiConfigs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiConfigsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiConfigs>>>
export type GetApiConfigsQueryError = unknown


export function useGetApiConfigs<TData = Awaited<ReturnType<typeof getApiConfigs>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiConfigs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiConfigs>>,
          TError,
          Awaited<ReturnType<typeof getApiConfigs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiConfigs<TData = Awaited<ReturnType<typeof getApiConfigs>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiConfigs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiConfigs>>,
          TError,
          Awaited<ReturnType<typeof getApiConfigs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiConfigs<TData = Awaited<ReturnType<typeof getApiConfigs>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiConfigs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiConfigs<TData = Awaited<ReturnType<typeof getApiConfigs>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiConfigs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiConfigsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export type postApiConfigsResponse200 = {
  data: PostApiConfigs200
  status: 200
}

export type postApiConfigsResponse409 = {
  data: unknown
  status: 409
}
    
export type postApiConfigsResponseSuccess = (postApiConfigsResponse200) & {
  headers: Headers;
};
export type postApiConfigsResponseError = (postApiConfigsResponse409) & {
  headers: Headers;
};

export type postApiConfigsResponse = (postApiConfigsResponseSuccess | postApiConfigsResponseError)

export const getPostApiConfigsUrl = () => {


  

  return `/api/configs`
}

export const postApiConfigs = async (postApiConfigsBody: PostApiConfigsBody, options?: RequestInit): Promise<postApiConfigsResponse> => {
  
  return customInstance<postApiConfigsResponse>(getPostApiConfigsUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postApiConfigsBody,)
  }
);}




export const getPostApiConfigsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiConfigs>>, TError,{data: PostApiConfigsBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiConfigs>>, TError,{data: PostApiConfigsBody}, TContext> => {

const mutationKey = ['postApiConfigs'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiConfigs>>, {data: PostApiConfigsBody}> = (props) => {
          const {data} = props ?? {};

          return  postApiConfigs(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiConfigsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiConfigs>>>
    export type PostApiConfigsMutationBody = PostApiConfigsBody
    export type PostApiConfigsMutationError = unknown

    export const usePostApiConfigs = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiConfigs>>, TError,{data: PostApiConfigsBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiConfigs>>,
        TError,
        {data: PostApiConfigsBody},
        TContext
      > => {

      const mutationOptions = getPostApiConfigsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type patchApiConfigsConfigIdResponse200 = {
  data: PatchApiConfigsConfigId200
  status: 200
}

export type patchApiConfigsConfigIdResponse409 = {
  data: unknown
  status: 409
}
    
export type patchApiConfigsConfigIdResponseSuccess = (patchApiConfigsConfigIdResponse200) & {
  headers: Headers;
};
export type patchApiConfigsConfigIdResponseError = (patchApiConfigsConfigIdResponse409) & {
  headers: Headers;
};

export type patchApiConfigsConfigIdResponse = (patchApiConfigsConfigIdResponseSuccess | patchApiConfigsConfigIdResponseError)

export const getPatchApiConfigsConfigIdUrl = (configId?: number | null,) => {


  

  return `/api/configs/${configId}`
}

export const patchApiConfigsConfigId = async (patchApiConfigsConfigIdBody: PatchApiConfigsConfigIdBody,
    configId?: number | null, options?: RequestInit): Promise<patchApiConfigsConfigIdResponse> => {
  
  return customInstance<patchApiConfigsConfigIdResponse>(getPatchApiConfigsConfigIdUrl(configId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchApiConfigsConfigIdBody,)
  }
);}




export const getPatchApiConfigsConfigIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiConfigsConfigId>>, TError,{data: PatchApiConfigsConfigIdBody;configId?: number | null}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchApiConfigsConfigId>>, TError,{data: PatchApiConfigsConfigIdBody;configId?: number | null}, TContext> => {

const mutationKey = ['patchApiConfigsConfigId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiConfigsConfigId>>, {data: PatchApiConfigsConfigIdBody;configId?: number | null}> = (props) => {
          const {data,configId} = props ?? {};

          return  patchApiConfigsConfigId(data,configId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchApiConfigsConfigIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiConfigsConfigId>>>
    export type PatchApiConfigsConfigIdMutationBody = PatchApiConfigsConfigIdBody
    export type PatchApiConfigsConfigIdMutationError = unknown

    export const usePatchApiConfigsConfigId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiConfigsConfigId>>, TError,{data: PatchApiConfigsConfigIdBody;configId?: number | null}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiConfigsConfigId>>,
        TError,
        {data: PatchApiConfigsConfigIdBody;configId?: number | null},
        TContext
      > => {

      const mutationOptions = getPatchApiConfigsConfigIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type postApiDeleteConfigsConfigIdResponse200 = {
  data: PostApiDeleteConfigsConfigId200
  status: 200
}
    
export type postApiDeleteConfigsConfigIdResponseSuccess = (postApiDeleteConfigsConfigIdResponse200) & {
  headers: Headers;
};
;

export type postApiDeleteConfigsConfigIdResponse = (postApiDeleteConfigsConfigIdResponseSuccess)

export const getPostApiDeleteConfigsConfigIdUrl = (configId?: number | null,) => {


  

  return `/api/delete-configs/${configId}`
}

export const postApiDeleteConfigsConfigId = async (configId?: number | null, options?: RequestInit): Promise<postApiDeleteConfigsConfigIdResponse> => {
  
  return customInstance<postApiDeleteConfigsConfigIdResponse>(getPostApiDeleteConfigsConfigIdUrl(configId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getPostApiDeleteConfigsConfigIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiDeleteConfigsConfigId>>, TError,{configId?: number | null}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiDeleteConfigsConfigId>>, TError,{configId?: number | null}, TContext> => {

const mutationKey = ['postApiDeleteConfigsConfigId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiDeleteConfigsConfigId>>, {configId?: number | null}> = (props) => {
          const {configId} = props ?? {};

          return  postApiDeleteConfigsConfigId(configId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiDeleteConfigsConfigIdMutationResult = NonNullable<Awaited<ReturnType<typeof postApiDeleteConfigsConfigId>>>
    
    export type PostApiDeleteConfigsConfigIdMutationError = unknown

    export const usePostApiDeleteConfigsConfigId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiDeleteConfigsConfigId>>, TError,{configId?: number | null}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiDeleteConfigsConfigId>>,
        TError,
        {configId?: number | null},
        TContext
      > => {

      const mutationOptions = getPostApiDeleteConfigsConfigIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    